import _ from 'underscore';
import React from 'react';

import BroadcastCard from 'components/cards/BroadcastCard';
import SlideSection from 'components/SlideSection';

import CommonPropTypes from 'utils/propTypes/common';

const PopularBroadcasts = ({ data }) => (
	<SlideSection title="Мы рекомендуем посмотреть">
		{_(data).map((item) => (
			<BroadcastCard key={item._id} data={item} />
		))}
	</SlideSection>
);

PopularBroadcasts.propTypes = {
	data: CommonPropTypes.entities.isRequired
};

export default PopularBroadcasts;
